<script lang="ts">
  import type { Guide, Spot } from "../../types";
  import CompleteSticker from "./complete-sticker.svelte";
  import MapPreview from "./map-preview.svelte";
  import { read, update } from "../../data/persistence";

  export let guide: Guide;
  export let spot: Spot;

  let readVisited = read(["guides", "visited"], {});

  $: visited = $readVisited;

  function toggle() {
    const id = spot.id;

    update(["guides", "visited"], (visited: { [id: string]: boolean }) => {
      let wasVisited = visited && visited[id] === true;

      return { ...visited, [id]: !wasVisited };
    });
  }
</script>

<div class="Container">
  {#if spot.isCompletable}
    <div class="CompleteBanner">
      <CompleteSticker complete={visited[spot.id]} on:toggle={toggle} />
    </div>
  {/if}

  <div class="Content">
    {#if spot.title}
      <h1 class="Title">{spot.title}</h1>
    {/if}

    {#if spot.description}
      <div class="Description">
        {@html spot.description}
      </div>
    {/if}

    {#if spot.mapId && spot.showMap}
      <MapPreview {spot} {guide} />
    {/if}
  </div>
</div>

<style>
  .Container {
    box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.25);
    background: white;
    border-radius: 12px;
    flex: 1 0;
    min-height: 100%;
    font-size: 16px;
    line-height: 1.4em;
    text-align: left;
    width: 100%;
  }

  .Title {
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding: 24px 24px 0;
  }

  .Description {
    padding: 24px;
  }

  .Description :global(*:first-child) {
    margin-top: 0;
  }

  .Description :global(*:last-child) {
    margin-bottom: 0;
  }

  .Description :global(img),
  .Description :global(video),
  .Description :global(audio) {
    margin: 0 auto;
    max-width: 100%;
  }

  .CompleteBanner {
    align-items: center;
    background-image: url($lib/wave-tile.svg);
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    display: flex;
    justify-content: center;
    border: 4px solid white;
    padding: 16px;
  }
</style>
